import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'tier-form-drawer'
}

import { ref, computed, watch, onBeforeUnmount, getCurrentInstance } from 'vue'
import axios from 'axios'
import { Auth } from 'aws-amplify'
import { API_LOCATION } from '@/api-config'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  show: { type: Boolean, default: false },
  tier: { type: Object, default: null },
  // sort_order for a NEW tier (appended at the end); ordering is managed by
  // drag-to-reorder in the list, not by a form field.
  nextSortOrder: { type: Number, default: 0 }
},
  emits: ['close', 'saved'],
  setup(__props, { emit }) {

const props = __props





const { proxy } = getCurrentInstance() as any

const companyId = localStorage.getItem('companyId')
const companyGroupId = JSON.parse(localStorage.getItem('group') || '{}').id
const baseUrl = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}`

const isEdit = computed(() => !!(props.tier && props.tier.id))

const saving = ref(false)
const errs = ref<any>({})
const form = ref<any>(defaultForm())

function defaultForm() {
  return { name: '', commission_percent: null, commission_flat: null, commission_base: 'total' }
}

function loadForm() {
  errs.value = {}
  if (props.tier) {
    form.value = {
      name: props.tier.name,
      commission_percent: props.tier.commission_percent == null ? null : parseFloat(props.tier.commission_percent),
      commission_flat: props.tier.commission_flat == null ? null : parseFloat(props.tier.commission_flat),
      commission_base: props.tier.commission_base
    }
  } else {
    form.value = defaultForm()
  }
}

async function authConfig() {
  const session = await Auth.currentSession()
  return { headers: { Authorization: (session as any).idToken.jwtToken } }
}

// House convention: new lambdas return JSON errors; older ones return strings.
function parseError(err: any, fallback: string) {
  const data = err?.response?.data
  if (data) {
    try {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data
      if (parsed && parsed.error) return parsed
    } catch (e) { /* not JSON */ }
    if (typeof data === 'string' && data.length > 0 && data.length < 200) return { error: data }
  }
  return { error: fallback }
}

async function save() {
  errs.value = {}
  if (!form.value.name || !form.value.name.trim()) { errs.value = { name: 'Name is required' }; return }
  const pct = form.value.commission_percent === '' || form.value.commission_percent == null ? null : parseFloat(form.value.commission_percent)
  const flat = form.value.commission_flat == null ? null : parseFloat(form.value.commission_flat)
  if (pct == null && flat == null) {
    errs.value = { commission_percent: 'Set a percent or a flat amount' }
    return
  }
  if (pct != null && (Number.isNaN(pct) || pct < 0 || pct > 100)) {
    errs.value = { commission_percent: 'Percent must be between 0 and 100' }
    return
  }

  saving.value = true
  try {
    const config = await authConfig()
    const body: any = {
      name: form.value.name.trim(),
      commission_percent: pct,
      commission_flat: flat,
      commission_base: form.value.commission_base
    }
    if (isEdit.value) {
      // sort_order untouched on edit; drag-to-reorder owns it
      await axios.put(`${baseUrl}/affiliate-tiers/${props.tier.id}`, body, config)
    } else {
      body.sort_order = props.nextSortOrder
      await axios.post(`${baseUrl}/affiliate-tiers`, body, config)
    }
    proxy.$notify({
      type: 'success',
      message: isEdit.value ? 'Tier saved' : 'Tier created',
      icon: 'tim-icons icon-check-2'
    })
    emit('saved')
    emit('close')
  } catch (err: any) {
    const parsed = parseError(err, 'The tier could not be saved')
    if (parsed.field) errs.value = { [parsed.field]: parsed.error }
    proxy.$notify({ type: 'danger', message: parsed.error, icon: 'tim-icons icon-alert-circle-exc' })
  } finally {
    saving.value = false
  }
}

function onClose() {
  emit('close')
}

function onEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape') onClose()
}

watch(() => props.show, (visible) => {
  if (visible) {
    document.addEventListener('keydown', onEscKey)
    loadForm()
  } else {
    document.removeEventListener('keydown', onEscKey)
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscKey)
})

return { __sfc: true,props, emit, proxy, companyId, companyGroupId, baseUrl, isEdit, saving, errs, form, defaultForm, loadForm, authConfig, parseError, save, onClose, onEscKey }
}

})